/* PUS – husk side, filter, sortering og position på Brugte smykker */
(() => {
  const PATH = '/pages/brugte-smykker';
  const STORAGE_KEY = 'pus-preowned-return-state:' + PATH;

  const onTargetPage = () => window.location.pathname.replace(/\/$/, '') === PATH;

  const init = () => {
    if (!onTargetPage()) return;

    const root = document.querySelector('.section-pus-preowned-products .pus-preowned-products');
    if (!root || root.dataset.pusReturnStateReady === '1') return;
    root.dataset.pusReturnStateReady = '1';

    const pagination = root.querySelector('[data-pus-pagination]');
    const sort = root.querySelector('[data-pus-sort]');
    if (!pagination) return;

    const currentState = () => {
      const activePage = root.querySelector('[data-pus-pagination] .pus-preowned-products__page.is-active[data-pus-page]');
      const activeFilter = root.querySelector('[data-pus-filter].is-active');
      return {
        page: Math.max(1, parseInt(activePage?.dataset.pusPage || '1', 10) || 1),
        filter: activeFilter?.dataset.pusFilter || 'all',
        sort: sort?.value || 'featured'
      };
    };

    const writeUrlState = () => {
      const state = currentState();
      const url = new URL(window.location.href);

      if (state.page > 1) url.searchParams.set('pus-page', String(state.page));
      else url.searchParams.delete('pus-page');

      if (state.filter !== 'all') url.searchParams.set('pus-type', state.filter);
      else url.searchParams.delete('pus-type');

      if (state.sort !== 'featured') url.searchParams.set('pus-sort', state.sort);
      else url.searchParams.delete('pus-sort');

      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      return state;
    };

    const saveReturnState = () => {
      const state = writeUrlState();
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          ...state,
          scrollY: window.scrollY,
          pageUrl: window.location.pathname + window.location.search,
          savedAt: Date.now()
        }));
      } catch (error) {}
    };

    const pageNumber = () => currentState().page;

    const goToPage = targetPage => {
      let guard = 0;
      while (pageNumber() !== targetPage && guard < 50) {
        guard += 1;
        const current = pageNumber();
        const step = current < targetPage ? current + 1 : current - 1;
        const button = Array.from(root.querySelectorAll('[data-pus-page]')).find(item => {
          return !item.disabled && parseInt(item.dataset.pusPage || '0', 10) === step;
        });
        if (!button) break;
        button.click();
      }
    };

    const restoreFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      const wantedPage = Math.max(1, parseInt(params.get('pus-page') || '1', 10) || 1);
      const wantedFilter = params.get('pus-type') || 'all';
      const wantedSort = params.get('pus-sort') || 'featured';

      if (sort && Array.from(sort.options).some(option => option.value === wantedSort) && sort.value !== wantedSort) {
        sort.value = wantedSort;
        sort.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const filterButton = Array.from(root.querySelectorAll('[data-pus-filter]')).find(button => {
        return (button.dataset.pusFilter || 'all') === wantedFilter;
      });
      if (filterButton && !filterButton.classList.contains('is-active')) filterButton.click();

      goToPage(wantedPage);
      writeUrlState();

      let saved = null;
      try {
        saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (error) {}

      const navigation = performance.getEntriesByType?.('navigation')?.[0];
      const cameBack = navigation?.type === 'back_forward';
      const sameUrl = saved?.pageUrl === window.location.pathname + window.location.search;
      const fresh = saved?.savedAt && Date.now() - saved.savedAt < 2 * 60 * 60 * 1000;

      if (cameBack && sameUrl && fresh && Number.isFinite(Number(saved.scrollY))) {
        const y = Number(saved.scrollY);
        window.setTimeout(() => window.scrollTo({ top: y, behavior: 'auto' }), 450);
        window.setTimeout(() => window.scrollTo({ top: y, behavior: 'auto' }), 750);
      }
    };

    root.addEventListener('click', event => {
      const productLink = event.target.closest('a[href*="/products/"]');
      if (productLink) {
        saveReturnState();
        return;
      }

      if (event.target.closest('[data-pus-filter], [data-pus-page]')) {
        window.setTimeout(writeUrlState, 0);
      }
    }, true);

    if (sort) sort.addEventListener('change', () => window.setTimeout(writeUrlState, 0));

    restoreFromUrl();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', init);
})();

/* PUS – AI-markering: diskret, skarp tekst uden filter-sløring */
(() => {
  const STYLE_ID = 'pus-ai-disclosure-crisp-style';

  const addStyle = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.pus-ai-disclosure{display:inline-flex!important;align-items:center!important;justify-content:center!important;padding:2px 5px 1px!important;border:1px solid rgba(17,17,17,.11)!important;border-radius:3px!important;background:#fff!important;color:rgba(17,17,17,.55)!important;box-shadow:none!important;overflow:visible!important;font-family:Arial,Helvetica,sans-serif!important;font-size:9px!important;font-weight:600!important;line-height:1.05!important;letter-spacing:.03em!important;text-transform:uppercase!important;white-space:nowrap!important;-webkit-font-smoothing:antialiased!important;text-rendering:geometricPrecision!important;}',
      '.pus-ai-disclosure .pus-ai-disclosure-icon{display:none!important;}',
      '.pus-ai-disclosure-host[data-pus-ai-disclosure-status="modified"]>.pus-ai-disclosure::before{content:"AI MODIFIED";}',
      '.pus-ai-disclosure-host[data-pus-ai-disclosure-status="full"]>.pus-ai-disclosure::before{content:"AI GENERATED";}',
      '@media screen and (max-width:740px){.pus-ai-disclosure{padding:1px 3px 1px!important;font-size:6px!important;}}'
    ].join('');
    document.head.appendChild(style);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStyle, { once: true });
  } else {
    addStyle();
  }

  document.addEventListener('shopify:section:load', addStyle);
})();